import styles from "./styles/vocal-remover-application-description.module.scss";
import Image from "next/image";
import {
  useMobile,
  useNarrowDesktop,
  useWideDesktop,
} from "@/hooks/use-responsive";

interface VocalRemoverApplicationDescriptionProps {
  image: string;
  title: string;
  description: string;
  alignment: "left" | "right";
}

const VocalRemoverApplicationDescription = ({
  image,
  title,
  description,
  alignment,
}: VocalRemoverApplicationDescriptionProps) => {
  const { isMobile } = useMobile();
  const { isNarrowDesktop } = useNarrowDesktop();
  const { isWideDesktop } = useWideDesktop();
  return (
    <div
      className={`${styles.wrapper} ${!isMobile ? (alignment === "left" ? styles.left_wrapper : styles.right_wrapper) : ""}`}
    >
      <Image
        className={styles.image}
        src={image}
        alt={""}
        width={imageWidthFactory(isNarrowDesktop, isWideDesktop)}
        height={isMobile ? 220 : 290}
      />
      <div className={styles.description_wrapper}>
        <div className={styles.title}>{title}</div>
        <div className={styles.description}>{description}</div>
      </div>
    </div>
  );
};

const imageWidthFactory = (
  isNarrowDesktop: boolean,
  isWideDesktop: boolean,
) => {
  if (isNarrowDesktop) {
    return 400;
  }

  if (isWideDesktop) {
    return 600;
  }

  return 500;
};

export default VocalRemoverApplicationDescription;
